export default __webpack_public_path__ + "static/media/GoodMannerWithYourParents_05.b13ab0e8.png";